import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

/** Model Form **/
import { ModelFieldDirective } from './model-field.directive';
import { ModelFormComponent } from './model-form.component';

/** Form Fields **/
import { InputComponent } from './fields/input.component';
import { EmailComponent } from './fields/email.component';
import { NumberComponent } from './fields/number.component';
import { RadioComponent } from './fields/radio.component';
import { SelectComponent } from './fields/select.component';
import { SubmitComponent } from './fields/submit.component';
import { SwitchComponent } from './fields/switch.component';
import { TextComponent } from './fields/text.component';

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule
	],
	exports: [
		ModelFormComponent
	],
	declarations: [
		ModelFormComponent,
		ModelFieldDirective,
		InputComponent,
		EmailComponent,
		NumberComponent,
		RadioComponent,
		SelectComponent,
		SubmitComponent,
		SwitchComponent,
		TextComponent
	],
	entryComponents: [
		InputComponent,
		EmailComponent,
		NumberComponent,
		RadioComponent,
		SelectComponent,
		SubmitComponent,
		SwitchComponent,
		TextComponent
	]
})
export class ModelFormModule { }
